module.exports = __webpack_public_path__ + "img/index_hysd.5aaa8667.png";